import Home from "@/views/Home/Home.vue";
import Profile from "@/views/Profile/Profile.vue";
import Dashboard from "@/views/Dashboard/Dashboard.vue";
import Kits from "@/views/Kits/Kits.vue";
import Results from "@/views/Results/Results.vue";
import Returns from "@/views/Returns/Returns.vue";
import Schedules from "@/views/Schedules/Schedules.vue";
import HealthIdDigital from "@/views/HealthIdDigital/HealthIdDigital.vue";
import RegisterKit from "../views/RegisterKit/RegisterKit";
import ForgotPassword from "@/views/ForgotPassword/ForgotPassword";
import RecoverPassword from "@/views/RecoverPassword/RecoverPassword";
import CarePlan from "../components/CarePlan/CarePlan";
import CoordinatedCare from "../components/CoordinatedCare/CoordinatedCare";
import CardHealthId from "@/components/CardHealthId/CardHealthId";

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    children: []
  },
  {
    path: "/perfil",
    name: "profile",
    component: Profile,
    children: []
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    children: []
  },

  {
    path: "/kits",
    name: "kits",
    component: Kits,
    children: []
  },
  {
    path: "/resultados",
    name: "results",
    component: Results,
    children: []
  },
  {
    path: "/devolutivas",
    name: "returns",
    component: Returns,
    children: []
  },
  {
    path: "/agendamentos",
    name: "schedules",
    component: Schedules,
    children: []
  },
  {
    path: "/cadastrar-kit",
    name: "cadastrar_kit",
    component: RegisterKit,
    children: []
  },
  {
    path: "/esqueceu-senha",
    name: "forgot",
    component: ForgotPassword,
    children: []
  },
  {
    path: "/recuperar-senha",
    name: "recover",
    component: RecoverPassword,
    children: []
  },
  {
    path: "/healthid-digital",
    name: "healthid-digital",
    component: HealthIdDigital,
    children: []
  },
  {
    path: "/care-plan",
    name: "care-plan",
    component: CarePlan,
    children: []
  },
  {
    path: "/coordinated-care",
    name: "coordinated-care",
    component: CoordinatedCare,
    children: []
  },
  {
    path: "/cardhealthid",
    name: "recover",
    component: CardHealthId,
    children: []
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/routes.js